import { useState } from "react";
import { post } from "../networking/RequestService";

function useUnpopProfile(profileId) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const unpopProfile = async () => {
        setLoading(true);
        setError(null);

        const payload = {
            fn: "unpop",
            profile: profileId,
            multiple: false,
        };

        try {
            const response = await post(payload);
            if (response?.data?.stat === "nok") throw new Error(response.data.text);
            return { data: response.data };
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { unpopProfile, loading, error };
}

export default useUnpopProfile;
